
import './App.css';
import {
  BrowserRouter,
  Routes,
  Route
} from "react-router-dom";
import Home from './Pages/Home/Home';
import About from './Pages/About/About';
import Header from './Pages/Header/Header';
import ProjectDetails from './Pages/ProjectDetails/ProjectDetails';
import Blog from './Pages/Blog/Blog';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Header></Header>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/home" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/details/:projectId" element={<ProjectDetails />} />
        </Routes>

      </BrowserRouter>

    </div>
  );
}

export default App;
